export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export function isValidGuid(guid: string | undefined | null): boolean {
  if (!guid) return false;
  if (guid === EMPTY_GUID) return false;
  
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return guidRegex.test(guid);
}

export function filterValidGuids(guids: (string | undefined | null)[]): string[] {
  return guids.filter((guid): guid is string => isValidGuid(guid));
}